/* eslint-disable */
export function strToInt32(byteGuid) {
    let newId = convert_uuid_can_read(byteGuid);
    let strnum = newId.substr(0, 4);
    let strnumnew = strnum[2] + strnum[3] + strnum[0] + strnum[1];
    let numchar1 = parseInt(strnumnew, 0x10);
    return numchar1;
}

function convert_uuid_can_read(str) {
    var string__ = "0123456789abcdef";
    var __id = str;
    var newid = "";
    for (let i = 0; i < __id.length; i++) {
        var numchar = __id.charCodeAt(i).toString(16);
        let s = 4 - numchar.length;
        var ch = "";
        for (let n = 0; n < s; n++) {
            ch += "0";
        }
        newid += ch + numchar;
    }
    return newid;
}
